import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  TableContainer,
  Paper,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  IconButton,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import {
  getAlbaranes,
  getLineasAlbaran,
  updateAlbaran,
  updateLineasAlbaran,
  getTotalAlbaran,
  deleteAlbaranLine,
  getTotalesLineaAlbaran,
  getAlbaranesExport,
} from "../service/apiAlbaran";
import { getProveedores } from "../service/apiProveedores";
import { getAlmacenes } from "../service/apiAlmacenes";
import { getEstadoAlbaran } from "../service/apiEstadosAlbaran";
import { getSeries } from "../service/apiSeries";
import { getMetodosDePago } from "../service/apiMetodosDePago";
import { getResiduoByIdAndAlmacen } from "../service/apiResiduos";
import { getResiduos } from "../service/apiResiduos";
import Modal from "../modal/modal";
import DeleteIcon from "@mui/icons-material/Delete";
import PdfGenerator from "../components/pdfGenerator";
import FilterBox from "../components/filterBox";
import config from "../config";
import { FaEdit } from "react-icons/fa";
import format from "date-fns/format";
import Titulo from "../components/titulos";
import ClearIcon from "@mui/icons-material/Clear";
import ArticleIcon from "@mui/icons-material/Article";
import AddIcon from "@mui/icons-material/Add";
import ConfirmModal from "../modal/ConfirmModal";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { logDOM } from "@testing-library/react";

const UpdateAlbaran = ({ datos }) => {
  const [albaranes, setAlbaranes] = useState([]);
  const [filters, setFilters] = useState(config.filtrosAlbaran);
  const celdas = [
    "Editar",
    "Imprimir",
    "Eliminar",
    "Id",
    "Consecutivo",
    "Serie",
    "Fecha",
    "Proveedor",
    "Importe",
    "Importe Anual",
    "Almacen",
    "Estado",
    "Método Pago",
    "REF",
    "Albarán Entrada",
    "Código",
    "Matricula",
    "Peso Entrada",
    "Peso Salida",
    "Peso Final",
  ];
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [datosFiltrados, setDatosFiltrados] = useState(datos);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectAlbaran, setSelectAlbaran] = useState({
    Id: 0,
    REF: "",
    Fecha: "",
    Proveedor: "",
    Almacen: "",
    Estado: "",
    Nif: "",
    "Peso Entrada": "",
    "Peso Salida": "",
    "Peso Final": "",
  });
  const [selectUpdateAlbaran, setSelectUpdateAlbaran] = useState({
    alb_id: "",
    alb_su_ref: "",
    alb_fecha_creacion: "",
    alb_proveedor_id: 0,
    alb_almacen_id: 0,
    alb_estado_id: 0,
  });
  const [selectUpdateLineaAlbaran, setSelectUpdateLineaAlbaran] = useState({
    lin_id: 0,
    lin_alb_id: 0,
    lin_res_id: 0,
    cantXKilo: 0,
    precioXalmacen: 0,
    subtotal: 0,
    tipo_iva: 0,
    total_linea: 0,
  });
  const [lineasAlbaran, setLineasAlbaran] = useState([]);
  const [openDialogLine, setOpenDialogLine] = useState(false);
  const [proveedores, setProveedores] = useState([]);
  const [almacenes, setAlmacenes] = useState([]);
  const [estados, setEstados] = useState([]);
  const [series, setSeries] = useState([]);
  const [metodosPago, setMetodoPago] = useState([]);
  const [residuos, setResiduos] = useState([]);
  const [total, setTotal] = useState();
  const [totalParcial, setTotalParcial] = useState();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [pdfData, setPdfData] = useState(null);
  const [currentPdfConsecutivo, setCurrentPdfConsecutivo] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [messageModalDelete, setMessageModalDelete] = useState(
    "¿Estás seguro de eliminar este albarán?",
  );
  const [isCompleted, setIsCompleted] = useState(false);
  const [deleteAlbaran, setDeleteAlbaran] = useState();
  const [sortConfig, setSortConfig] = useState({
    key: "res_ler",
    direction: "asc",
  });
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);
  const [countxPage, setCountxPage] = useState(25);

  const [totalLineasAlbaran, setTotalLineasAlbaran] = useState([]);
  const [albaranesFull, setAlbaranesFull] = useState([]);
  //funcion para agregar totales a albaranes por pagina y albaranes totales
  const mapAlbaranWithTotals = async (albaran, Proveedores) => {
    try {
      const totalesXproveedor = await getTotalesLineaAlbaran(albaran.Codigo);

      //console.log(totalesXproveedor);
      const proveedor = totalesXproveedor.find(
        (p) => Number(p.prov_id) === Number(albaran.Codigo),
      );
      // Año del albarán
      const anioAlbaran = new Date(albaran.Fecha).getFullYear();
      //const anioAlbaran = new Date().getFullYear(); //Año Actual

      // Buscar año dentro del proveedor
      const anioData = proveedor?.anios?.find((a) => a.anio === anioAlbaran);

      // Subtotal del albarán
      const totalSubtotal =
        anioData?.albaranes?.find((a) => a.lin_alb_id === albaran.Id)
          ?.subtotal ?? 0;

      // Total anual del proveedor (ese año)

      const anioActual = new Date().getFullYear();
      let totalLinea;
      if (anioActual === anioData.anio) {
        totalLinea = anioData.anio === anioAlbaran ? anioData?.totalAnual : 0;
      }

      let subtotal, importe, importeAnual;

      subtotal = Number(totalSubtotal ?? 0).toFixed(3);
      importe = Number(totalSubtotal ?? 0).toFixed(3);
      importeAnual = Number(totalLinea ?? 0).toFixed(3);

      return {
        ...albaran,
        "Total Subtotal": subtotal,
        Importe: importe,
        "Importe Anual": importeAnual,
        Anio: anioAlbaran,
      };
    } catch (error) {
      console.error(`Error procesando ${albaran.Id}`, error);

      return {
        ...albaran,
        "Total Subtotal": 0,
        Importe: 0,
        "Importe Anual": 0,
      };
    }
  };

  const fetchAlbaranes = async () => {
    try {
      const Proveedores = await getProveedores();
      setProveedores(Proveedores);
      const responseAll = await getAlbaranes("all");
      const albaranesFullMapped = await Promise.all(
        responseAll.map((a) => mapAlbaranWithTotals(a, Proveedores)),
      );
      setAlbaranesFull(albaranesFullMapped);

      const response = await getAlbaranes(countxPage);
      const albaranesPageMapped = await Promise.all(
        response.map((a) => mapAlbaranWithTotals(a, Proveedores)),
      );
      setAlbaranes(albaranesPageMapped);
    } catch (error) {
      console.error("Error al obtener los albaranes => ", error);
    }
  };
  const fetchAlmacenes = async () => {
    try {
      const response = await getAlmacenes();
      setAlmacenes(response);
    } catch (error) {
      console.error("Error al obtener los almacenes desde editar", error);
    }
  };
  const fetchEstados = async () => {
    try {
      const response = await getEstadoAlbaran();
      setEstados(response);
    } catch (error) {
      console.error("Error al obtener los estados desde editar", error);
    }
  };
  const fetchSeries = async () => {
    try {
      const response = await getSeries();
      setSeries(response);
    } catch (error) {
      console.error(
        "Error al obtener las series de albaran - desde editar",
        error,
      );
    }
  };
  const fetchMetodosPago = async () => {
    try {
      const response = await getMetodosDePago();
      setMetodoPago(response);
    } catch (error) {
      console.error(
        "Error al obtener los metodos de pago. - desde editar",
        error,
      );
    }
  };
  const fecthResiduos = async () => {
    try {
      const response = await getResiduos();
      setResiduos(response);
    } catch (error) {
      console.error("Error al obtener los residuos desde editar", error);
    }
  };
  useEffect(() => {
    const fetchInit = async () => {
      setLoading(true);
      try {
        await Promise.all([
          fetchAlbaranes(),
          fetchAlmacenes(),
          fetchEstados(),
          fetchSeries(),
          fetchMetodosPago(),
          fecthResiduos(),
        ]);
      } finally {
        setLoading(false);
      }
    };
    fetchInit();
  }, [countxPage]);

  useEffect(() => {
    const result = filtrarAlbaranes(albaranesFull);
    setDatosFiltrados(result);
  }, [filters, albaranes]);

  const handleChangeRowsPerPage = (newLimit) => {
    setRowsPerPage(newLimit);
    setPage(0);
    setCountxPage(newLimit);
  };
  const datosPaginados = (datosFiltrados || []).slice(
    page * rowsPerPage,
    rowsPerPage === "all"
      ? (datosFiltrados || []).length
      : (page + 1) * rowsPerPage,
  );
  const handleEditAlbaran = async (albaran) => {
    try {
      const response = await getLineasAlbaran(albaran.Id);

      if (response.length > 0) {
        setLineasAlbaran(response);
        setTotalLineasAlbaran(response);
        setOpenDialogLine(true);
        const lineasActualizadas = response.map((linea) => ({
          lin_id: linea.Id,
          lin_alb_id: selectAlbaran?.Id,
          lin_res_id: linea.Id,
          cantXKilo: linea.Cantidad,
          precioXalmacen: linea.Precio,
          subtotal: linea.Subtotal,
          tipo_iva: linea.IVA,
          total_linea: linea.Total,
        }));

        //Sumar los subtotales de las lineas para compararlos con el total anual
        setTotalLineasAlbaran(
          response.reduce((acc, linea) => acc + linea.Subtotal, 0),
        );

        setSelectUpdateLineaAlbaran(lineasActualizadas);
      } else {
        setLineasAlbaran([]);
        setSnackbarMessage("Este Albaran no contiene Lineas.");
        setShowSnackbar(true);
      }
    } catch (error) {
      console.error("Error al encontrar lineas de Albaran:", error);
      setSnackbarMessage("Error al encontrar lineas de Albaran.");
      setShowSnackbar(true);
    }

    try {
      const proveedorActual = proveedores.find(
        (prov) => prov.prov_nombre === albaran.Proveedor,
      );

      const response = await getTotalAlbaran(proveedorActual.prov_id);

      const total = response.data.results[0].Total;

      const datosAnio = response.data.results;

      const fecha = albaran.Fecha;
      const years = new Date(fecha).getUTCFullYear(); //año actual
      datosAnio.forEach((d) => {
        if (years === d.anio) {
          setTotal(d);
          setTotalParcial(d);
        }
      });

      if (total != null && !isNaN(total) && Number(total).toFixed(2) > 3000) {
        setModalMessage(
          `
          <p>
            El total para el proveedor <strong>${
              proveedorActual.prov_nombre
            }</strong> es mayor a 3000, es de
            <span style="color: red; font-weight: bold;">
              ${total.toFixed(2)}
            </span>
          </p>
        `,
        );
        setShowModal(true);
      }
      setSelectAlbaran(albaran);
      setOpenDialog(true);
    } catch (error) {
      console.error("Error al encontrar total para ese proveedor", error);
    }
  };
  const handleInputChangeAlbaran = async (e) => {
    const { name, value } = e.target;
    const selectedValue = e.target.value;

    if (name === "REF") {
      const keyName = "alb_su_ref";
      setSelectUpdateAlbaran((prevState) => ({
        ...prevState,
        [keyName]: value,
      }));
    } else if (name === "Fecha") {
      const keyName = "alb_fecha_creacion";
      setSelectUpdateAlbaran((prevState) => ({
        ...prevState,
        [keyName]: value,
      }));
    } else if (name === "Proveedor") {
      const keyName = "alb_proveedor_id";
      const selectedOption = proveedores.find(
        (proveedor) => proveedor.prov_nombre === selectedValue,
      );
      const id = selectedOption.prov_id;
      setSelectUpdateAlbaran((prevState) => ({
        ...prevState,
        [keyName]: id,
      }));
    } else if (name === "Serie") {
      const keyName = "alb_serie_id";
      const selectedOption = series.find(
        (serie) => serie.ser_tipo === selectedValue,
      );
      const id = selectedOption.ser_id;
      setSelectUpdateAlbaran((prevState) => ({
        ...prevState,
        [keyName]: id,
      }));
    } else if (name === "Metodo Pago") {
      const keyName = "alb_met_id";
      const selectedOption = metodosPago.find(
        (metodo) => metodo.met_nombre === selectedValue,
      );
      const id = selectedOption.met_id;
      setSelectUpdateAlbaran((prevState) => ({
        ...prevState,
        [keyName]: id,
      }));
    } else if (name === "Almacen") {
      const keyName = "alb_almacen_id";
      const selectedOption = almacenes.find(
        (almacen) => almacen.alm_nombre === selectedValue,
      );
      const id = selectedOption.alm_id;
      setSelectUpdateAlbaran((prevState) => ({
        ...prevState,
        [keyName]: id,
      }));

      if (Array.isArray(lineasAlbaran)) {
        const updatedLineas = await Promise.all(
          lineasAlbaran.map(async (linea) => {
            try {
              const response = await getResiduoByIdAndAlmacen(id, linea.Id);
              return {
                ...linea,
                Precio: response[0].precio,
                Total: (linea.Cantidad * response[0].precio).toFixed(2),
              };
            } catch (error) {
              console.error(
                "Error al obtener los precios desde editar albarán",
              );
              return linea; // En caso de error, no modificar la línea
            }
          }),
        );
        setLineasAlbaran(updatedLineas);
      } else {
        console.error("Error en actualizacion de precios");
      }
    } else if (name === "Estado") {
      const keyName = "alb_estado_id";
      const selectedOption = estados.find(
        (estado) => estado.est_alb_nombre === selectedValue,
      );
      const id = selectedOption.est_alb_id;
      setSelectUpdateAlbaran((prevState) => ({
        ...prevState,
        [keyName]: id,
      }));
    }
    setSelectAlbaran((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleFilterChange = (name, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };
  const filtrarAlbaranes = (albaranes) => {
    const resultado = albaranes.filter((albaran) => {
      return Object.entries(filters).every(([key, value]) => {
        if (!value || typeof value !== "string" || !value.trim()) return true;
        const field = albaran[key];
        return field?.toString().toLowerCase().includes(value.toLowerCase());
      });
    });
    if (resultado) {
      return resultado;
    }
  };
  const filterObject = (obj) => {
    const filteredObj = {};
    // Recorrer todas las claves del objeto
    for (const key in obj) {
      // Comprobar si el valor de la propiedad no está vacío, null o undefined
      if (
        obj[key] !== null &&
        obj[key] !== undefined &&
        obj[key] !== "" &&
        obj[key] !== false &&
        obj[key] !== 0
      ) {
        filteredObj[key] = obj[key]; // Si tiene un valor, añadirlo al objeto filtrado
      }
    }

    return filteredObj;
  };
  const handleChangeLineasalbaran = async (index, field, value) => {
    const updatedLineas = [...lineasAlbaran]; // Clonar el array
    let updatedLinea = { ...updatedLineas[index] }; // Clonar la línea específica

    if (field === "Residuo") {
      const selectedAlmacen = almacenes.find(
        (almacen) => almacen.alm_nombre === selectAlbaran.Almacen,
      );
      const selectedOption = residuos.find(
        (residuo) => residuo.res_nombre === value,
      );

      if (!selectedAlmacen || !selectedOption) {
        console.error("Error: No se encontró el almacén o el residuo");
        return;
      }

      try {
        const response = await getResiduoByIdAndAlmacen(
          selectedAlmacen.alm_id,
          selectedOption.res_id,
        );

        if (response.length === 0) {
          setSnackbarMessage(
            "Error: el residuo no tiene precios para ese almacén",
          );
          setShowSnackbar(true);
          return;
        }

        updatedLinea = {
          ...updatedLinea,
          Id: response[0].res_id,
          Residuo: response[0].res_nombre,
          Precio: response[0].precio,
          IVA: response[0].res_iva,
          Subtotal:
            parseFloat(updatedLinea.Cantidad) * parseFloat(response[0].precio),
          Total: response[0].res_iva
            ? (
                parseFloat(updatedLinea.Cantidad) *
                parseFloat(response[0].precio) *
                (1 + parseFloat(response[0].res_iva) / 100)
              ).toFixed(2)
            : (
                parseFloat(updatedLinea.Cantidad) *
                parseFloat(response[0].precio)
              ).toFixed(2),
        };
      } catch (error) {
        console.error(
          "Error al obtener los precios desde editar albarán",
          error,
        );
        setSnackbarMessage(
          "Error: el residuo no tiene precios para ese almacén",
        );
        setShowSnackbar(true);
        return;
      }
    } else {
      updatedLinea[field] = value;
    }

    updatedLinea.Subtotal = (
      updatedLinea.Cantidad * updatedLinea.Precio
    ).toFixed(2);
    if (updatedLinea.IVA) {
      updatedLinea.Total = (
        updatedLinea.Subtotal *
        (1 + parseFloat(updatedLinea.IVA) / 100)
      ).toFixed(2);
    } else {
      updatedLinea.Total = (
        updatedLinea.Cantidad * updatedLinea.Precio
      ).toFixed(2);
    }

    updatedLineas[index] = updatedLinea;

    setLineasAlbaran(updatedLineas);
    const linea = { ...updatedLineas[index] };

    if (field === "Cantidad") {
      const updatedLineas = [...lineasAlbaran];
      const linea = { ...updatedLineas[index] };

      // 1. Actualizar cantidad, subtotal y total en la línea
      linea.Cantidad = parseFloat(value) || 0;
      const nuevoSubtotal = linea.Cantidad * parseFloat(linea.Precio);
      linea.Subtotal = nuevoSubtotal.toFixed(2);
      linea.Total = (nuevoSubtotal + nuevoSubtotal * (linea.IVA / 100)).toFixed(
        2,
      );
      updatedLineas[index] = linea;

      setLineasAlbaran(updatedLineas);

      // 2. Sumar totales de todas las líneas visibles
      const totalLineas = updatedLineas.reduce(
        (acc, l) => acc + parseFloat(l.Subtotal || 0),
        0,
      );

      const totalActual = parseFloat(total.Total); // del objeto original que ya usas
      const diferencia = totalLineas - totalActual;

      let nuevoTotal;

      if (Math.abs(diferencia) < 0.01) {
        nuevoTotal = totalLineas;
      } else {
        const lineaOriginal = lineasAlbaran[index];
        const subtotalAnterior = lineaOriginal
          ? parseFloat(lineaOriginal.Subtotal)
          : 0;
        const subtotalNuevo = parseFloat(linea.Subtotal);
        const ajuste = subtotalNuevo - subtotalAnterior;

        nuevoTotal = totalActual + ajuste;
      }

      setTotal({
        ...total,
        Total: parseFloat(nuevoTotal.toFixed(2)) || 0,
      });
    }

    setSelectUpdateLineaAlbaran((prevState) => {
      const updatedState = Array.isArray(prevState) ? [...prevState] : [];

      const newLine = {
        lin_id: index, // usamos el index como identificador único
        lin_res_id: parseInt(updatedLinea.Id),
        cantXKilo: updatedLinea.Cantidad,
        precioXalmacen: updatedLinea.Precio,
        subtotal:
          parseFloat(updatedLinea.Precio) * parseFloat(updatedLinea.Cantidad),
        tipo_iva: updatedLinea.IVA || 0,
      };

      const existingIndex = updatedState.findIndex((l) => l.lin_id === index);

      if (existingIndex !== -1) {
        updatedState[existingIndex] = {
          ...updatedState[existingIndex],
          ...newLine,
        };
      } else {
        updatedState.push(newLine);
      }

      return updatedState;
    });
  };
  const handleSaveAlbaran = async () => {
    const dataAlbaran = filterObject(selectUpdateAlbaran);
    const alb_id = Number(selectAlbaran?.Id);
    let lineasFinal;

    const metodoPago = metodosPago.find(
      (metodo) => metodo.met_nombre === selectAlbaran["Metodo Pago"],
    );
    const proveedor = proveedores.find(
      (proveedor) => proveedor.prov_nombre === selectAlbaran.Proveedor,
    );

    if (!alb_id) {
      setSnackbarMessage(
        "No se puede guardar: el albarán no tiene un ID válido",
      );
      setShowSnackbar(true);
      return;
    }
    try {
      if (Object.keys(dataAlbaran).length > 0) {
        const responseAlbaran = await updateAlbaran(alb_id, dataAlbaran);

        if (responseAlbaran === 200 || responseAlbaran === 204) {
          setSnackbarMessage("Albarán actualizado con éxito...");
          setShowSnackbar(true);
          setTimeout(() => {
            window.location.reload();
          }, 2000);

          return;
        }
      } else {
        setSnackbarMessage("No hay datos en el albarán para actualizar.");
        setShowSnackbar(true);
      }
      const lineasModificadas = (
        Array.isArray(selectUpdateLineaAlbaran)
          ? selectUpdateLineaAlbaran
          : [selectUpdateLineaAlbaran]
      )
        .filter((linea) => linea.lin_res_id && Object.keys(linea).length > 1)
        .map((linea) => ({
          lin_res_id: Number(linea.lin_res_id),
          lin_alb_id: alb_id,
          ...Object.fromEntries(
            Object.entries(linea)
              .filter(([key]) => key !== "lin_id")
              .map(([key, value]) => [key, Number(value)]),
          ),
        }));

      if (lineasModificadas.length === 0) {
        setSnackbarMessage("No hay líneas modificadas para guardar.");
        setShowSnackbar(true);
      }

      if (lineasAlbaran.length !== lineasModificadas.length) {
        lineasFinal = lineasAlbaran.map((item) => {
          const lineaOriginal = lineasModificadas.find(
            (l) => l.lin_res_id === item.Id,
          );
          const subtotal = parseFloat(item.Subtotal);
          const iva = parseFloat(item.IVA);
          const totalLinea = parseFloat(
            (subtotal * (1 + iva / 100)).toFixed(2),
          );

          return {
            lin_res_id: item.Id,
            lin_alb_id: alb_id,
            cantXKilo: item.Cantidad,
            precioXalmacen: item.Precio,
            subtotal: subtotal,
            tipo_iva: iva,
          };
        });
      } else {
        lineasFinal = lineasModificadas;
      }
      const responseLineas = await updateLineasAlbaran(alb_id, lineasFinal);

      if (responseLineas.status === 200) {
        //setSelectUpdateLineaAlbaran([]);
        // ==================================== Crear el pdf ====================================
        const lineasConTotal = lineasFinal.map((item) => {
          const subtotal = parseFloat(item.subtotal);
          const iva = parseFloat(item.tipo_iva);

          const total_linea = parseFloat(
            (subtotal * (1 + iva / 100)).toFixed(2),
          );

          return {
            ...item,
            total_linea,
          };
        });
        const totalLineas = lineasConTotal.reduce(
          (item, cont) => item + parseFloat(cont.total_linea),
          0,
        );

        const keyMap = {
          Id: "articulo",
          Residuo: "descripcion",
          Precio: "precio",
          IVA: "impuesto",
          Cantidad: "cantidad",
          Subtotal: "subtotal",
          Total: "total",
        };
        // Función para transformar los objetos y poder enviarlos a create pdf.
        const transformData = (data, map) =>
          data.map((item) =>
            Object.fromEntries(
              Object.entries(item).map(([key, value]) => {
                const mappedKey = map[key] || key;

                // Si es uno de los campos numéricos, conviértelo
                const isNumericField = [
                  "cantidad",
                  "precio",
                  "impuesto",
                  "subtotal",
                  "total",
                ].includes(mappedKey);
                const parsedValue = isNumericField ? parseFloat(value) : value;

                return [mappedKey, parsedValue];
              }),
            ),
          );
        const rows = transformData(lineasAlbaran, keyMap);
        const impuestos = rows.map((row) => row.impuesto);

        setPdfData({
          selectedSerie: selectAlbaran.Serie,
          consecutivo: selectAlbaran.Consecutivo,
          suRef: selectAlbaran.REF,
          selectedState: selectAlbaran.Estado,
          currentDate: selectAlbaran.Fecha,
          proveedor: selectAlbaran.Proveedor,
          codCliente: selectAlbaran.Codigo,
          almacenId: 0,
          albaranEntrada: selectAlbaran["Albarán Entrada"],
          selectMetodo: metodoPago.met_id,
          nifCliente: proveedor.prov_nif,
          numTarjeta: proveedor.prov_num_tarjeta_ecopay,
          numCuenta: proveedor.prov_cta_bancaria,
          matricula: selectAlbaran.Matricula,
          rows: rows,
          allImpuestos: impuestos,
          totalSum: parseFloat(totalLineas),
          pesoCamionEntrada: selectAlbaran["Peso Entrada"] || 0,
          pesoCamionSalida: selectAlbaran["Peso Salida"] || 0,
          pesoFinal: selectAlbaran["Peso Final"] || 0,
          direccion: proveedor.prov_direccion || "",
        });
        setCurrentPdfConsecutivo(selectAlbaran.Consecutivo);

        setSnackbarMessage("Albarán y líneas actualizados con éxito.");
        setShowSnackbar(true);
        setTimeout(async () => {
          //setOpenDialogLine(false);

          setOpenDialog(false);
          await fetchAlbaranes();
          //   window.location.reload();
        }, 2000);
      } else {
        setSnackbarMessage("Error al actualizar las líneas del albarán.");
        setOpenDialog(false);
        setShowSnackbar(true);
      }
    } catch (error) {
      console.error("Error al actualizar el albarán", error);
      setSnackbarMessage("Ocurrió un error inesperado al guardar los cambios.");
      setShowSnackbar(true);
    }
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setModalMessage("");
    setLineasAlbaran([]);
    setSelectUpdateLineaAlbaran([]);
  };
  const handleAddRow = () => {
    const newRow = {
      Id: "",
      Residuo: "",
      Cantidad: 0,
      Precio: 0,
      IVA: 0,
      Subtotal: 0,
      Total: 0,
    };
    const updateLineas = [...lineasAlbaran, newRow];
    setLineasAlbaran(updateLineas);
  };
  const deleteRow = (index) => {
    const updatedLineas = lineasAlbaran.filter((_, i) => i !== index);

    // 1. Calcular la suma de subtotales de las líneas restantes
    const totalLineas = updatedLineas.reduce(
      (acc, l) => acc + parseFloat(l.Subtotal || 0),
      0,
    );

    const totalActual = parseFloat(total.Total);
    const diferencia = totalLineas - totalActual;

    let nuevoTotal;

    if (Math.abs(diferencia) < 0.01) {
      // Las líneas representan todo el total → usar la sumatoria
      nuevoTotal = totalLineas;
    } else {
      const lineaEliminada = lineasAlbaran[index];
      const subtotalEliminado = lineaEliminada
        ? parseFloat(lineaEliminada.Subtotal)
        : 0;

      nuevoTotal = totalActual - subtotalEliminado;
    }

    // 2. Actualizar líneas y total
    setLineasAlbaran(updatedLineas);
    setTotal({
      ...total,
      Total: parseFloat(nuevoTotal.toFixed(2)) || 0,
    });
  };
  const handleCrearAlbaran = async (albaran) => {
    let rows = [];
    let impuestos = "";
    let totalLineas = 0;

    const metodoPago = metodosPago.find(
      (metodo) => metodo.met_nombre === albaran["Metodo Pago"],
    );
    const proveedor = proveedores.find(
      (proveedor) => proveedor.prov_nombre === albaran.Proveedor,
    );
    const almacenActual = almacenes.find(
      (almacen) => almacen.alm_nombre === albaran.Almacen,
    );
    try {
      const response = await getLineasAlbaran(albaran.Id);

      if (response.length !== 0) {
        setLineasAlbaran(response);
        setOpenDialogLine(true);
        const lineasActualizadas = response.map((linea) => ({
          lin_id: linea.Id,
          lin_alb_id: selectAlbaran?.Id,
          lin_res_id: linea.Id,
          cantXKilo: linea.Cantidad,
          precioXalmacen: linea.Precio,
          subtotal: linea.Subtotal,
          tipo_iva: linea.IVA,
          total: linea.Total,
        }));

        totalLineas = response.reduce(
          (item, cont) => item + parseFloat(cont.Total),
          0,
        );

        setSelectUpdateLineaAlbaran(lineasActualizadas);
        const keyMap = {
          Id: "articulo",
          Residuo: "descripcion",
          Precio: "precio",
          IVA: "impuesto",
          Cantidad: "cantidad",
          Subtotal: "subtotal",
          Total: "total",
        };
        const transformData = (data, map) =>
          data.map((item) =>
            Object.fromEntries(
              Object.entries(item).map(([key, value]) => [
                map[key] || key,
                value,
              ]),
            ),
          );

        rows = transformData(response, keyMap);
        impuestos = rows.map((row) => row.impuesto);
      } else {
        setLineasAlbaran([]);
        setSnackbarMessage("Este Albaran no contiene Lineas.");
        setShowSnackbar(true);
      }
    } catch (error) {
      console.error("Error al encontrar lineas de Albaran:", error);
      setSnackbarMessage("Error al encontrar lineas de Albaran.");
      setShowSnackbar(true);
    }

    setPdfData({
      selectedSerie: albaran.Serie,
      consecutivo: albaran.Consecutivo,
      suRef: albaran.REF,
      selectedState: albaran.Estado,
      currentDate: albaran.Fecha,
      proveedor: albaran.Proveedor,
      codCliente: albaran.Codigo,
      almacenId: almacenActual.alm_id,
      albaranEntrada: albaran["Albarán Entrada"],
      direccion: proveedor.prov_direccion,
      selectMetodo: metodoPago.met_id,
      nifCliente: proveedor.prov_nif,
      numTarjeta: proveedor.prov_num_tarjeta_ecopay,
      numCuenta: proveedor.prov_cta_bancaria,
      matricula: albaran.Matricula,
      rows: rows,
      allImpuestos: impuestos,
      totalSum: totalLineas,
      pesoCamionEntrada: albaran["Peso Entrada"] || 0,
      pesoCamionSalida: albaran["Peso Salida"] || 0,
      pesoFinal: albaran["Peso Final"] || 0,
    });
    setCurrentPdfConsecutivo(albaran.Consecutivo);
  };
  const handleDeleteAlbaran = (albaran) => {
    setDeleteAlbaran(albaran.Id);
    setMostrarModal(true);
  };
  const confirmarEliminacion = async () => {
    try {
      setMessageModalDelete("Eliminando...");
      setIsLoading(true);
      const response = await deleteAlbaranLine(deleteAlbaran);
      if (response === "Albarán eliminado correctamente") {
        const responseAlbaranes = await getAlbaranes();
        setTimeout(() => {
          setIsLoading(false);
          setMessageModalDelete("¡Albarán eliminado correctamente!");
          setIsCompleted(true);

          setTimeout(() => {
            setIsCompleted(false);
            setMostrarModal(false);
            setMessageModalDelete("");
            setAlbaranes(responseAlbaranes);
            window.location.reload();
          }, 1500);
        }, 2000);
      } else {
        setIsLoading(false);
        setMostrarModal(false);
        setSnackbarMessage("Error al eliminar linea Albarán.");
        setShowSnackbar(true);
      }
    } catch (error) {
      console.error("Error al eliminar albarán");
    }
  };
  const cancelarEliminacion = () => {
    setMostrarModal(false);
  };
  const obtenerKeyDesdeNombre = (nombre) => {
    const mapa = {
      Id: "Id",
      Consecutivo: "Consecutivo",
      Serie: "Serie",
      Fecha: "Fecha",
      Proveedor: "Proveedor",
      Almacen: "Almacen",
      Estado: "Estado",
      REF: "REF",
      "Albarán Entrada": "Albaran Entrada",
      Código: "Codigo",
      Matricula: "Matricula",
      "Método Pago": "Metodo Pago",
      "Peso Entrada": "Peso Entrada",
      "Peso Salida": "Peso Salida",
      "Peso Final": "Peso Final",
    };
    return mapa[nombre] || nombre;
  };
  //Funcion para ordenamiento de la tabla por codigo y por albaran
  const sortableKeys = [
    "Id",
    "Consecutivo",
    "Serie",
    "Fecha",
    "Proveedor",
    "Importe",
    "Importe Anual",
    "Almacen",
    "Estado",
    "Método Pago",
  ];
  const handleSort = (key) => {
    if (key === "Método Pago") {
      key = "Metodo Pago";
    }
    setSortConfig((prevConfig) => {
      const newDirection =
        prevConfig.key === key && prevConfig.direction === "asc"
          ? "desc"
          : "asc";
      const sorted = [...datosFiltrados].sort((a, b) => {
        if (a[key] < b[key]) return newDirection === "asc" ? -1 : 1;
        if (a[key] > b[key]) return newDirection === "asc" ? 1 : -1;
        return 0;
      });
      setDatosFiltrados(sorted);
      return { key, direction: newDirection };
    });
  };
  return (
    <>
      <Titulo type="albaran" name="Editar Albaranes" />
      <Box key="filterBox" className="filterBox">
        <FilterBox
          origen="Albaranes"
          filters={filters}
          setFilters={setFilters}
          onFilterChange={handleFilterChange}
          data={albaranesFull}
        />
      </Box>
      <Box className="container">
        <Box className="containerTablas">
          <TableContainer
            key="tableContainer"
            component={Paper}
            className="tableContainer"
          >
            <Table>
              {loading ? (
                <TableBody>
                  <TableRow>
                    <TableCell
                      key="carga de datos"
                      align="center"
                      sx={{
                        height: 500,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <CircularProgress sx={{ color: "#1abd9c" }} />
                      <span style={{ marginTop: 10 }}>
                        {" "}
                        Cargando Datos Albaranes...{" "}
                      </span>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <>
                  <TableHead>
                    <TableRow key="titulos">
                      {celdas.map((header) => (
                        <TableCell
                          onClick={() => handleSort(header)}
                          className="tableHeaderCell"
                          key={header}
                        >
                          {header}
                          {sortableKeys.includes(header) &&
                            (sortConfig.key === header &&
                            sortConfig.direction === "desc" ? (
                              <ArrowDropUpIcon className="headerTableIcons" />
                            ) : (
                              <ArrowDropDownIcon className="headerTableIcons" />
                            ))}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {datosPaginados.map((albaran) => (
                      <TableRow
                        key={`albaran-${albaran.Id}`}
                        className="tableCeldas"
                      >
                        {celdas.map((celda) => {
                          if (celda === "Editar") {
                            return (
                              <TableCell
                                key={`editar-${albaran.Id}`}
                                align="center"
                              >
                                <IconButton
                                  title="Editar datos de albarán"
                                  onClick={() => handleEditAlbaran(albaran)}
                                  color="primary"
                                >
                                  <FaEdit />
                                </IconButton>
                                {showModal && (
                                  <Modal
                                    message={modalMessage}
                                    onClose={handleCloseModal}
                                  />
                                )}
                              </TableCell>
                            );
                          }
                          if (celda === "Imprimir") {
                            return (
                              <TableCell
                                key={`imprimir-${albaran.Id}`}
                                align="center"
                              >
                                <ArticleIcon
                                  onClick={() => handleCrearAlbaran(albaran)}
                                  color="primary"
                                />
                                {pdfData &&
                                  pdfData.consecutivo === albaran.Consecutivo &&
                                  currentPdfConsecutivo ===
                                    albaran.Consecutivo && (
                                    <PdfGenerator
                                      data={pdfData}
                                      onComplete={() =>
                                        setCurrentPdfConsecutivo(null)
                                      }
                                    />
                                  )}
                              </TableCell>
                            );
                          }
                          if (celda === "Eliminar") {
                            return (
                              <TableCell
                                key={`eliminar-${albaran.Id}`}
                                align="center"
                              >
                                <DeleteIcon
                                  title="Eliminar un Albaran"
                                  color="error"
                                  onClick={() => handleDeleteAlbaran(albaran)}
                                />
                                {mostrarModal && (
                                  <ConfirmModal
                                    message={messageModalDelete}
                                    isLoading={isLoading}
                                    isCompleted={isCompleted}
                                    onConfirm={confirmarEliminacion}
                                    onCancel={cancelarEliminacion}
                                  />
                                )}
                              </TableCell>
                            );
                          }
                          const key = obtenerKeyDesdeNombre(celda);
                          let valor = albaran[key];
                          if (celda === "Fecha") {
                            const fecha = new Date(valor);
                            fecha.setMinutes(
                              fecha.getMinutes() + fecha.getTimezoneOffset(),
                            );
                            valor = valor ? format(fecha, "dd/MM/yyyy") : "";
                          }
                          if (celda === "Importe Anual") {
                            <TableCell key={`${key}-${albaran.Id}`}>
                              {albaran["Importe Anual"]}
                            </TableCell>;
                          }

                          return (
                            <TableCell key={`${key}-${albaran.Id}`}>
                              {valor}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </>
              )}
            </Table>
          </TableContainer>
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" mt={2} px={14}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "90%",
            margin: "auto",
          }}
        >
          <span>Mostrar: </span>
          {[25, 50, 100, "all"].map((limit) => (
            <button
              key={limit}
              onClick={() => handleChangeRowsPerPage(limit)}
              style={{
                marginRight: 10,
                background: rowsPerPage === limit ? "#1abd9c" : "#e0e0e0",
                color: rowsPerPage === limit ? "#fff" : "#000",
                border: "none",
                padding: "5px 10px",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              {limit === "all" ? "Todos" : limit}
            </button>
          ))}
        </div>
      </Box>

      {/*  ==================== edicion Datos de albaran ==================== */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="lg"
        fullWidth
        disableEscapeKeyDown={true}
      >
        <DialogTitle
          variant="h5"
          sx={{ margin: "20px auto", textAlign: "center" }}
        >
          Editar Albarán
        </DialogTitle>
        <Typography
          variant="p"
          sx={{
            width: "90%",
            display: "block",
            margin: "10px auto",
            textAlign: "right",
          }}
        >
          Total albaran anual:
          {typeof total?.Total === "number" ? (
            <span style={{ color: total.Total > 3000 ? "red" : "green" }}>
              {total.Total.toFixed(2)}
            </span>
          ) : (
            "0.00"
          )}
        </Typography>
        {/* Renderizar DialogContent solo si selectAlbaran tiene datos */}
        {selectAlbaran.Id ? (
          <DialogContent
            key={`dialog-content-${selectAlbaran.Id}`}
            style={{ paddingTop: "10px" }}
          >
            {/* Albarán */}

            <Grid container spacing={2}>
              {Object.keys(selectAlbaran).map((key) => {
                if (key === "Id") return null; // Excluir el campo Id
                if (key === "Fecha") {
                  return (
                    <Grid item xs={12} sm={6} key={`fecha-${selectAlbaran.Id}`}>
                      <TextField
                        label={key}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        name={key}
                        type="date"
                        value={
                          selectAlbaran.Fecha
                            ? new Date(selectAlbaran.Fecha)
                                .toISOString()
                                .split("T")[0]
                            : ""
                        }
                        onChange={handleInputChangeAlbaran}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  );
                }
                if (key === "Serie") {
                  return (
                    <Grid item xs={12} sm={6} key={`serie-${selectAlbaran.Id}`}>
                      <FormControl fullWidth margin="dense" variant="outlined">
                        <InputLabel>{key}</InputLabel>
                        <Select
                          value={selectAlbaran[key]}
                          onChange={handleInputChangeAlbaran}
                          label={key}
                          name={key}
                        >
                          {series.map((serie) => (
                            <MenuItem key={serie.ser_id} value={serie.ser_tipo}>
                              {serie.ser_tipo}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  );
                }
                if (key === "Metodo Pago") {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      key={`metodo-${selectAlbaran.Id}`}
                    >
                      <FormControl fullWidth margin="dense" variant="outlined">
                        <InputLabel>{key}</InputLabel>
                        <Select
                          value={selectAlbaran[key]}
                          onChange={handleInputChangeAlbaran}
                          label={key}
                          name={key}
                        >
                          {metodosPago.map((metodo) => (
                            <MenuItem
                              key={metodo.met_id}
                              value={metodo.met_nombre}
                            >
                              {metodo.met_nombre}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  );
                }
                if (
                  key === "Peso Entrada" ||
                  key === "Peso Salida" ||
                  key === "Peso Final"
                ) {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      key={`${key}-${selectAlbaran.Id}`}
                    >
                      <TextField
                        label={key}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        name={key}
                        value={selectAlbaran[key] || ""}
                        onChange={handleInputChangeAlbaran}
                      />
                    </Grid>
                  );
                }
                if (key === "Proveedor") {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      key={`proveedor-${selectAlbaran.Id}`}
                    >
                      <FormControl fullWidth margin="dense" variant="outlined">
                        <InputLabel>{key}</InputLabel>
                        <Select
                          value={selectAlbaran[key]}
                          onChange={handleInputChangeAlbaran}
                          label={key}
                          name={key}
                        >
                          {proveedores.map((proveedor) => (
                            <MenuItem
                              key={proveedor.prov_id}
                              value={proveedor.prov_nombre}
                            >
                              {proveedor.prov_nombre}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  );
                }
                if (key === "Almacen") {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      key={`almacen-${selectAlbaran.Id}`}
                    >
                      <FormControl fullWidth margin="dense" variant="outlined">
                        <InputLabel>{key}</InputLabel>
                        <Select
                          value={selectAlbaran[key]}
                          onChange={handleInputChangeAlbaran}
                          label={key}
                          name={key}
                        >
                          {almacenes.map((almacen) => (
                            <MenuItem
                              key={almacen.alm_id}
                              value={almacen.alm_nombre}
                            >
                              {almacen.alm_nombre}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  );
                }
                if (key === "Estado") {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      key={`estado-${selectAlbaran.Id}`}
                    >
                      <FormControl fullWidth margin="dense" variant="outlined">
                        <InputLabel>{key}</InputLabel>

                        <Select
                          value={selectAlbaran[key]}
                          onChange={handleInputChangeAlbaran}
                          label={key}
                          name={key}
                        >
                          {estados.map((estado) => (
                            <MenuItem
                              key={estado.est_alb_id}
                              value={estado.est_alb_nombre}
                            >
                              {estado.est_alb_nombre}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  );
                }
                if (key === "Importe" || key === "Total Subtotal") {
                  return;
                }
                return (
                  <Grid item xs={12} sm={6} key={`${key}-${selectAlbaran.Id}`}>
                    <TextField
                      label={key}
                      margin="dense"
                      variant="outlined"
                      fullWidth
                      name={key}
                      value={selectAlbaran[key] || ""}
                      onChange={handleInputChangeAlbaran}
                    />
                  </Grid>
                );
              })}
            </Grid>

            {/* líneas de albarán */}
            <TableContainer>
              <DialogTitle sx={{ marginBottom: "5px" }}>
                {lineasAlbaran.length === 0 ? "No hay lineas disponibles" : ""}
              </DialogTitle>
              <Table>
                <TableBody>
                  {lineasAlbaran.map((item, index) => (
                    <TableRow key={item.id || index}>
                      <TableCell>
                        <Typography variant="p">{`${index + 1}`}</Typography>
                      </TableCell>
                      {Object.keys(item).map((key) => {
                        if (key === "Id") return null;
                        if (key === "Residuo") {
                          return (
                            <TableCell key={`linea-${index}-${key}`}>
                              <FormControl fullWidth margin="dense">
                                <Autocomplete
                                  freeSolo
                                  size="small"
                                  options={residuos}
                                  getOptionLabel={(option) =>
                                    typeof option === "string"
                                      ? option
                                      : `${option.res_id} - ${option.res_nombre}`
                                  }
                                  isOptionEqualToValue={(option, value) =>
                                    option.res_id === value?.res_id
                                  }
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.res_id}>
                                      {option.res_id} - {option.res_nombre}
                                    </li>
                                  )}
                                  onInputChange={(event, newInputValue) => {}}
                                  onChange={(event, newValue) => {
                                    if (newValue) {
                                      handleChangeLineasalbaran(
                                        index,
                                        key,
                                        typeof newValue === "string"
                                          ? newValue
                                          : newValue.res_nombre,
                                      );
                                    } else {
                                      handleChangeLineasalbaran(index, key, "");
                                    }
                                  }}
                                  value={
                                    item[key]
                                      ? residuos.find(
                                          (r) => r.res_nombre === item[key],
                                        ) || item[key]
                                      : null
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={key}
                                      variant="outlined"
                                      sx={{
                                        width: "300px",
                                      }}
                                    />
                                  )}
                                />
                              </FormControl>
                            </TableCell>
                          );
                        }
                        return (
                          <TableCell key={`linea-${index}-${key}`}>
                            <TextField
                              size="small"
                              label={key}
                              value={item[key]}
                              onChange={(e) =>
                                handleChangeLineasalbaran(
                                  index,
                                  key,
                                  e.target.value,
                                )
                              }
                              sx={{
                                width: "auto",
                                padding: "0",
                                margin: "0",
                              }}
                            />
                          </TableCell>
                        );
                      })}
                      <TableCell>
                        <Button
                          key={`eliminar_${index}`}
                          size="small"
                          color="error"
                          variant="outlined"
                          onClick={() => deleteRow(index)}
                        >
                          <DeleteIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <Button
                key="agregarFila"
                style={{ background: "#1abd9c", margin: "10px" }}
                variant="contained"
                onClick={handleAddRow}
                endIcon={<AddIcon />}
              >
                Agregar Fila
              </Button>
            </TableContainer>
          </DialogContent>
        ) : (
          <DialogContent
            key="dialog-content-empty"
            style={{ paddingTop: "10px" }}
          >
            <Typography variant="body1" align="center">
              Cargando datos del albarán...
            </Typography>
          </DialogContent>
        )}
        <DialogActions>
          <Button
            onClick={() => setOpenDialog(false)}
            style={{ background: "#dc3545", color: "#fff" }}
            sx={{ textTransform: "none" }}
            endIcon={<ClearIcon />}
          >
            Cancelar
          </Button>

          <Button
            style={{ background: "#1abd9c" }}
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
            endIcon={<ArticleIcon />}
            onClick={handleSaveAlbaran}
          >
            Crear Albarán
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowSnackbar(false)}
        message={snackbarMessage}
      />
    </>
  );
};

export default UpdateAlbaran;
